export default "./dist/stdassets/images/icons/file-print.png";